import * as _ from 'underscore'

import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpLocation, OpFile } from "../models/core"
import { ColumnInfo } from "../models/custom"
import { OpExportPluginParam } from "../models/util"


export class DataProviderGroupingLocation {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion

    // #region Public Methods

    public assignGroupingLocation = (groupingLocation: OpLocation, locations: OpLocation[], columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession(
            columns,
            pageNbr,
            pageSize,
            customWhereClause,
            Enums.ReferenceType.IdLocation,
            'OpxAssignGroupingLocation',
            'OpxAssignGroupingLocationResult',
            {
                groupingLocation: groupingLocation,
                locations: locations
            }
        )
    }

    public getGroupingLocationAssignedLocationsPaginated = (idLocation: number, columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocation>(
            columns,
            pageNbr,
            pageSize,
            customWhereClause,
            Enums.ReferenceType.IdLocation,
            'OpxGetGroupingLocationAssignedLocationsPaginated',
            'OpxGetGroupingLocationAssignedLocationsPaginatedResult',
            { idLocation: idLocation }
        )
    }

    public getGroupingLocationAssignedLocations = (idLocation: number): JQueryPromise<OpLocation[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetGroupingLocationAssignedLocations', { idLocation }, 'OpxGetGroupingLocationAssignedLocationsResult')
            .then((response: any[]) => response.map((opObj: any) => new OpLocation(opObj)))
    }

    public getGroupingLocationFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpLocation>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdLocation, 'OpxGroupingLocationFilter', 'OpxGroupingLocationFilterResult')
    }

    public groupingLocationExport = (referenceType: Enums.ReferenceType, columns: ColumnInfo[], customWhereClause: string, dllName: string, params: OpExportPluginParam[]) => {
        const requestArgs: any = {
            ReferenceType: referenceType,
            Columns: columns,
            CustomWhereClause: customWhereClause,
            DllName: dllName,
            exportParams: params != null ? params.map((param: OpExportPluginParam) => param.toJSON()) : null
        }

        return this.dataProvider
            .sendRequestWithSession('OpxGroupingLocationExport', requestArgs, 'OpxGroupingLocationExportResult')
            .then((data: any) => {
                if (data != null) {
                    return new OpFile(data)
                }

                return null
            })
    }

    public saveGroupingLocation = (opObj: OpLocation): JQueryPromise<OpLocation> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveGroupingLocation', { toBeSaved: opObj.toJSON() }, 'OpxSaveGroupingLocationResult')
            .then((response: any) => {
                if (response != null) {
                    const opLocation: OpLocation = new OpLocation(response)

                    return OpLocation
                        .loadNavigationProperties(this.dataProvider, [opLocation])
                        .then((locations: OpLocation[]) => {
                            return _.first(locations)
                        })
                }

                return null
            })
    }

    // #endregion

} 